// const baseURL = "http://192.168.29.201:5000/api/admin";
// const baseURL = "http://192.168.0.198:5000/api/admin";
const baseURL = "https://admin.roamjssln.com/api/admin";
// const baseURL = "https://development.roamjssln.com/api/admin";

export const login_endpoint = {
  login_API: baseURL + "/login"
};

export const auth_endpoint = {
  forgotPassword_API: baseURL + "/forgot-password",
  verifyOtp_API: baseURL + "/verify-otp",
  resetPassword_API: baseURL + "/reset-password",
  resendOtp_API: baseURL + "/resend-otp"
};

export const customerCare_endpoint = {
  getCustomerCare: baseURL + "/customer-care",
  createCustomerCare: baseURL + "/customer-care",
  updateCustomerCare: (id) => baseURL + `/customer-care/${id}`,
  deleteCustomerCare: (id) => baseURL + `/customer-care/${id}`,
  toggleCustomerCareStatus: (id) => baseURL + `/customer-care/${id}/toggle-status`
};

export const dashboard_endpoint = {
  dashboard_API: baseURL + "/dashboard"
};

export const users_endpoint = {
  users_API: baseURL + "/users"
};

export const busOwners_endpoint = {
  busOwners_API: baseURL + "/bus-owners",
  getBusOwnerById: (id) => baseURL + `/bus-owners/${id}`,
  approvedBusOwnerById: (id) => baseURL + `/bus-owners/${id}`,
  updateBusOwner: (id) => baseURL + `/bus-owners/${id}`,
  deleteBusOwner: (id) => baseURL + `/bus-owners/${id}`,
  addBusToOwnerApi: (ownerId) => baseURL + `/bus-owners/${ownerId}/buses`,
  activateBus: (busId) => baseURL + `/bus/activate/${busId}`,

};

export const booking_endpoint = {
  bookingFilter_API: baseURL + "/bookings/filter",
};

export const drivers_endpoint = {
  drivers_API: baseURL + "/drivers"
};

export const route_endpoint = {
  route_API: baseURL + "/routes"
};

export const conductors_endpoint = {
  conductors_API: baseURL + "/conductors"
};

export const bookings_endpoint = {
  bookings_API: baseURL + "/bookings",
  getBookingById: (id) => baseURL + `/bookings/${id}`,
  updateBooking: (id) => baseURL + `/bookings/${id}`,
  updateBookingStatus: (id) => baseURL + `/bookings/${id}/status`
};

export const customer_endpoints = {
  getCustomers: baseURL + "/users",
  getCustomerById: (id) => baseURL + `/users/${id}`,
  updateCustomer: (id) => baseURL + `/users/${id}`,
}

export const coupons_endpoint = {
  coupons_API: baseURL + "/coupons",
  getCouponById: (id) => baseURL + `/coupons/${id}`,
  updateCoupon: (id) => baseURL + `/coupons/${id}`,
  deleteCoupon: (id) => baseURL + `/coupons/${id}`
};

export const payment_endpoint = {
  payments_API: baseURL + "/payments",
  getPaymentById: (id) => baseURL + `/payments/${id}`,
  processPayment: (id) => baseURL + `/payments/${id}/process`,
  refundPayment: (id) => baseURL + `/payments/${id}/refund`
};

export const admin_profile_endpoint = {
  getAdminProfile: baseURL + "/profile",
  updateAdminProfile: baseURL + "/profile",
  changeAdminPassword: baseURL + "/change-password",
  updateAdminSettings: baseURL + "/settings"
};


export const influencers_endpoint = {
  influencers_API: baseURL + "/influencers",
  getInfluencerById: (id) => baseURL + `/influencers/${id}`,
  updateInfluencer: (id) => baseURL + `/influencers/${id}`,
  deleteInfluencer: (id) => baseURL + `/influencers/${id}`,
  updateInfluencerStatus: (id) => baseURL + `/influencers/${id}/status`
};


export const commission_endpoint = {
  getCommissionReports: baseURL + "/commissions/reports",
  getBusOwnerCommission: (id) => baseURL + `/bus-owners/${id}/commission`,
  updateBusOwnerCommission: (id) => baseURL + `/bus-owners/${id}/commission`,
  processCommissionPayout: (id) => baseURL + `/bus-owners/${id}/commission/payout`,

  getInfluencerCommissionses: baseURL + "/admin/commissions",
  getCommissionStats: baseURL + "/admin/commissions/stats",
  getCommissionById: (id) => baseURL + `/admin/commissions/${id}`,
  processBulkPayout: baseURL + "/admin/commissions/bulk-payout",

  processCommissionPayment: (ownerId) => baseURL + `/commission/pay/${ownerId}`,
  getCommissionPaymentHistory: (ownerId) => baseURL + `/commission/payments/${ownerId}`,
  getAllCommissionPayments: baseURL + `/commission/payments`,
  updatePaymentStatus: (paymentId) => baseURL + `/commission/payment/${paymentId}`
};

export const admin_term_endpoint = {
  getAllTerm: baseURL + "/terms",
 
};


export const admin_layout_endpoint = {
  getAllCategories: baseURL + "/categories",
  getAllLayout: baseURL + "/layouts",
  getLayoutsByBusType: (busType) => baseURL + `/layouts/bustype=${busType}`,
};

export const employee_endpoint = {
  employees_API: baseURL + "/employee",
  getEmployeeById: (id) => baseURL + `/employee/${id}`,
  updateEmployee: (id) => baseURL + `/employee/${id}`,
  deleteEmployee: (id) => baseURL + `/employee/${id}`,
  permanentDeleteEmployee: (id) => baseURL + `/employee/${id}/permanent`,
  bulkCreateEmployees: baseURL + "/employee/bulk",
  updatePassword: (id) => baseURL + `/employee/${id}/password`
};

export const freelancer_endpoint = {
  freelancers_API: '/freelancers',
  getFreelancerById: (id) => `/freelancers/${id}`,
  updateFreelancer: (id) => `/freelancers/${id}`,
  deleteFreelancer: (id) => `/freelancers/${id}`,
  permanentDeleteFreelancer: (id) => `/freelancers/${id}/permanent`,
  bulkCreateFreelancers: '/freelancers/bulk',
  updatePassword: (id) => `/freelancers/${id}/reset-password`,
  approveFreelancer: (id) => `/freelancers/${id}/approve`,
  rejectFreelancer: (id) => `/freelancers/${id}/reject`,
  toggleFreelancerStatus: (id) => `/freelancers/${id}/toggle-status`,
  updatePermissions: (id) => `/freelancers/${id}/permissions`,
  getFreelancerStats: '/freelancers/stats'
};

export const profit_endpoint = {
  getBusIncome: (busId) => baseURL + `/buses/${busId}/income`,
  getAllBusesIncome: baseURL + "/buses/income/all",
  getBusIncomeSummary: baseURL + "/buses/income/summary"
};

export const admin_expense_endpoint = {
  adminExpenses_API: baseURL + "/admin-expenses",
  getAdminExpenseById: (id) => baseURL + `/admin-expenses/${id}`,
  updateAdminExpense: (id) => baseURL + `/admin-expenses/${id}`,
  deleteAdminExpense: (id) => baseURL + `/admin-expenses/${id}`,
  approveAdminExpense: (id) => baseURL + `/admin-expenses/${id}/approve`,
  getAdminExpenseCategories: baseURL + "/admin-expenses/categories",
  getAdminExpenseDepartments: baseURL + "/admin-expenses/departments",
  getAdminExpenseStats: baseURL + "/admin-expenses/stats"
};

export const master_route_endpoint = {
  masterRoutes_API: baseURL + "/master-routes",
  getMasterRouteById: (id) => baseURL + `/master-routes/${id}`,
  updateMasterRoute: (id) => baseURL + `/master-routes/${id}`,
  deleteMasterRoute: (id) => baseURL + `/master-routes/${id}`,
  toggleMasterRouteStatus: (id) => baseURL + `/master-routes/${id}/status`,
  searchMasterRoutesByCities: baseURL + "/master-routes/search/cities",

  searchMasterRouteIntermediateStops: baseURL + "/master-routes/cities/masterroute",
  searchRouteIntermediateStops: baseURL + "/routes/cities/route",
  searchMasterRoutesByCitiesForForm: baseURL + "/master-routes/source-destination-cities",
};

export const gst_endpoint = {
  gstRates_API: baseURL + "/gst-management/rates",
  getGSTRateById: (id) => baseURL + `/gst-management/rates/${id}`,
  updateGSTRate: (id) => baseURL + `/gst-management/rates/${id}`,
  deleteGSTRate: (id) => baseURL + `/gst-management/rates/${id}`,
  getActiveGSTRates: baseURL + "/gst-management/rates/active",
  
  bulkCreateGSTRates: baseURL + "/gst-management/rates/bulk",
  bulkUpdateGSTRates: baseURL + "/gst-management/rates/bulk",
  
  getGSTConfig: baseURL + "/gst-management/config",
  updateGSTConfig: baseURL + "/gst-management/config",
  
  calculateGST: baseURL + "/gst-management/calculate",
  getCurrentRates: (serviceType) => baseURL + `/gst-management/current-rates/${serviceType}`,
  
  getGSTRateHistory: baseURL + "/gst-management/reports/history",
  getGSTSummary: baseURL + "/gst-management/reports/summary",
  gstr1: baseURL + "/gst/gstr1",
  gstr1CSV: baseURL + "/gst/gstr1/csv",
  gstr1PDF: baseURL + "/gst/gstr1/pdf",
  
  gstr3b: baseURL + "/gst/gstr3b",
  gstr3bCSV: baseURL + "/gst/gstr3b/csv",
  gstr3bPDF: baseURL + "/gst/gstr3b/pdf",
  
  dashboard: baseURL + "/gst/dashboard",
  
  invoices: baseURL + "/gst/invoices",
  invoiceById: (id) => baseURL + `/gst/invoices/${id}`,
  generateInvoices: baseURL + "/gst/invoices/generate",
  cancelInvoice: (id) => baseURL + `/gst/invoices/${id}/cancel`,
};

export const bookingPolicy_endpoint = {
  bookingPolicies_API: baseURL + "/booking-policies",
  getBookingPolicyById: (id) => baseURL + `/booking-policies/${id}`,
  createBookingPolicy: baseURL + "/booking-policies",
  updateBookingPolicy: (id) => baseURL + `/booking-policies/${id}`,
  deleteBookingPolicy: (id) => baseURL + `/booking-policies/${id}`,
  permanentDeleteBookingPolicy: (id) => baseURL + `/booking-policies/${id}/permanent`,
  toggleBookingPolicyStatus: (id) => baseURL + `/booking-policies/${id}/toggle-status`,
  getActiveBookingPolicy: baseURL + "/booking-policies/active",
  getFormattedPolicyText: (id) => baseURL + `/booking-policies/formatted/${id}`,
  validateCancellation: baseURL + "/booking-policies/validate-cancellation"
};
export const bus_endpoint = {
  getBusById: (id) => baseURL + `/buses/${id}`,
  activateBus: (busId) => baseURL + `/bus/activate/${busId}`,
  getAllBuses: baseURL + "/buses",
  updateBusStatus: (busId) => baseURL + `/buses/${busId}/status`,
  deleteBus: (busId) => baseURL + `/buses/${busId}`,
  getBusesByOwner: (ownerId) => baseURL + `/bus-owners/${ownerId}/buses`,
};

export const version_endpoint = {
  versions_API: baseURL + "/versions",
  latestVersions_API: baseURL + "/versions/latest/all",
  getLatestByApp: (appType) => baseURL + `/versions/latest/${appType}`,
  getVersionById: (id) => baseURL + `/versions/${id}`,
  createVersion: baseURL + "/versions",
  updateVersion: (id) => baseURL + `/versions/${id}`,
  deleteVersion: (id) => baseURL + `/versions/${id}`, 
  toggleVersionStatus: (id) => baseURL + `/versions/${id}/toggle-status`,  
  checkUpdate: baseURL + "/versions/check-update",
  versionStats: baseURL + "/versions/stats"
};

export const viewRoutes_endpoint = {
  getViewRoutes: baseURL + "/view-routes",
  getViewRouteById: (id) => baseURL + `/view-routes/${id}`,
  getViewRouteStats: baseURL + "/view-routes/stats",
  deactivateViewRoute: (id) => baseURL + `/view-routes/${id}`
};